import { apiEndpoints } from "../api-config";
import { requestJson } from "../http";

export type CompanyProfile = {
  name: string | null;
  logoUrl: string | null;
  description: string | null;
};

/** The company's public profile. Throws ApiError(404) for an unknown slug. */
export const getCompany = async (slug: string): Promise<CompanyProfile> => {
  const body = await requestJson<{ data: CompanyProfile }>(
    apiEndpoints(slug).company,
  );
  return body.data;
};
